<script setup lang="ts">
import { faArrowRotateLeft, faArrowRotateRight } from '@fortawesome/pro-light-svg-icons'

const { delta } = defineProps<{
  delta: number
}>()

const controls = inject(diKeys.mediaControls)
</script>

<template>
  <button
    class="group grid grid-cols-1 grid-rows-1 justify-center items-center min-w-[1.25em]"
    @click="controls?.seek(delta)"
  >
    <span class="text-[8px] row-start-1 col-start-1 leading-[12px]" v-text="Math.abs(delta)" />
    <Icon
      class="group-hover:rotate-0 transition-transform row-start-1 col-start-1"
      :class="delta > 0 ? '-rotate-45' : 'rotate-45'"
      :icon="delta > 0 ? faArrowRotateRight : faArrowRotateLeft"
    />
  </button>
</template>
